module.exports = __webpack_public_path__ + "static/media/achievement-master-chef.e8f82578.svg";